<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6">
      <v-card-title class="pa-7">
        Přehled dodavatelů
        <v-spacer class="mb-10"></v-spacer>
      </v-card-title>
      <v-card-text>
        <SuppliersFilters @filter="setFiltersAction" />

        <v-data-table
          v-model="supplier.selected"
          :headers="userHeadersByRole"
          :items="supplier.items"
          :options.sync="supplier.options"
          :server-items-length="supplier.serverItemsLength"
          :loading="supplier.loading"
          item-key="id"
          class="elevation-0"
          show-select
        >
          <template v-slot:item.id="{ item }">
            <router-link
              :to="{
                name: 'suppliers.detail',
                params: {
                  supplierId: item.id,
                },
              }"
            >
              {{ item.id }}
            </router-link>
          </template>
          <template v-slot:item.rated="{ item }">
            <YesNo :value="item.rated" />
          </template>
          <template v-slot:item.adminEnabled="{ item }">
            <EnabledDisabled :value="item.adminEnabled" />
          </template>
          <template v-slot:item.clientEnabled="{ item }">
            <EnabledDisabled :value="item.clientEnabled" />
          </template>
          <template v-slot:item.createdAt="{ item }">
            <DateTime :disable-time="false" :datetime="item.createdAt" />
          </template>
          <template v-slot:item.updatedAt="{ item }">
            <DateTime :disable-time="false" :datetime="item.updatedAt" />
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn-toggle color="primary" dense group>
              <v-btn
                :to="{ name: 'suppliers.edit', params: { supplierId: item.id } }"
                color="blue-grey"
                text
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn color="blue-grey" text @click="removeSupplier(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <template v-slot:footer>
            <SupplierActionFooter v-model="supplierFooter" @onVisibilityUpdate="loadSuppliers" />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import SuppliersFilters from '../../../components/filters/SuppliersFilters'
import EnabledDisabled from '../../../components/EnabledDisabled'
import SupplierActionFooter from '../../../components/product/SupplierActionFooter'
import DateTime from '../../../components/DateTime'
import YesNo from '../../../components/YesNo'

export default {
  name: 'Suppliers',
  components: {
    YesNo,
    DateTime,
    SupplierActionFooter,
    EnabledDisabled,
    SuppliersFilters,
  },
  mixins: [setFilters],
  data() {
    return {
      supplier: {
        selected: [],
        headers: [
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Název',
            value: 'name',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Hodnoceno',
            value: 'rated',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Administrátor',
            value: 'adminEnabled',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Zákazník',
            value: 'clientEnabled',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Vytvořeno',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Změněno',
            value: 'updatedAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      supplierFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.supplier.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'supplier.options': {
      handler() {
        this.loadSuppliers()
      },
    },
    '$route.query': {
      handler() {
        this.loadSuppliers()
      },
    },
    'supplier.selected': {
      handler() {
        this.supplierFooter.selectedData.items = this.supplier.selected
      },
    },
  },
  methods: {
    ...mapActions({
      searchSuppliers: 'supplier/searchSuppliers',
      deleteSupplier: 'supplier/deleteSupplier',
    }),
    loadSuppliers() {
      this.supplier.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.supplier.options,
      }
      this.supplierFooter.selectedData.params = searchParams
      this.searchSuppliers(searchParams)
        .then((response) => {
          this.supplierFooter.totalElements = response.data.totalElements
          this.supplier.items = response.data.items
          this.supplier.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.supplier.loading = false
        })
    },
    removeSupplier(id) {
      this.$confirm('', {
        title: 'Smazat dodavatele?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.supplier.loading = true
          this.deleteSupplier(id)
            .then(() => {
              this.loadSuppliers()
            })
            .finally(() => {
              this.supplier.loading = false
            })
        }
      })
    },
    setFiltersAction(filters) {
      this.supplier.options.page = 1
      this.setFilters(filters)
    },
    removeHtml(value) {
      return value.replace(/<p.*>.*?<\/p>/gi, '')
    },
  },
}
</script>
